Namespace 'Monitoring.Reports.Publications.Sections'

class Monitoring.Reports.Publications.Sections.OptionsView extends Backbone.View

  template: JST['backbone/templates/monitoring/reports/publications/options']

  initialize: (@availableSections = {}) ->
    # just set @sections

  render: ->
    @$el.html(@template( {section_name: @availableSections.section_name} ))
    section_view = new Monitoring.Reports.Publications.Sections.OptionView(@availableSections.subsections_names)
    @$('.section-options-container').append(section_view.render().el)
    return this